import React, { useState } from 'react'
import styles from './LazyImageLoader.module.scss'

interface LazyImageLoaderProps {
    lowSrc: string
    highSrc: string
    alt: string
}

export const LazyImageLoader: React.FC<LazyImageLoaderProps> = ({ lowSrc, highSrc, alt }) => {
    const [isHighResLoaded, setIsHighResLoaded] = useState(false)

    return (
        <div className={styles.ImageWrapper}>
            {/* Low-res */}
            {!isHighResLoaded && (
                <img
                    src={lowSrc}
                    alt=""
                    className={styles.LowResImage}
                />
            )}
            {/* High-res */}
            <img
                src={highSrc}
                alt={alt}
                onLoad={() => setIsHighResLoaded(true)}
                className={`${styles.HighResImage} ${isHighResLoaded ? styles.HighResImageLoaded : ''}`}
            />
        </div>
    )
}
